import ImageEditor from './ImageEditor';

export default ImageEditor;
export { CropData } from './ImageEditor';



// WEBPACK FOOTER //
// ./src/components/CoverPhotoEditor/ImageEditor/index.tsx